module.exports = __webpack_public_path__ + "img/create-folder-icon.8f58ffd8.svg";